export enum ShipmentStatus {
  CREATED = 'CREATED',
  REQUESTED = 'REQUESTED',
  ALLOCATED = 'ALLOCATED',
  IN_TRANSIT = 'IN_TRANSIT',
  DELAYED = 'DELAYED',
  CANCELLED = 'CANCELLED',
  DELIVERED = 'DELIVERED',
  COMPLETED = 'COMPLETED',
  REJECTED = 'REJECTED',
  TIMEOUT = 'TIMEOUT',
  ACCEPTED = 'ACCEPTED',
  INCOMPLETE = 'INCOMPLETE',
}

export enum AllocationWidgetType {
  REQUESTS_NOT_ASSIGNED = 'REQUESTS_NOT_ASSIGNED',
  REQUESTS_NOT_ANSWERED_TIMEOUT = 'REQUESTS_NOT_ANSWERED_TIMEOUT',
  UNALLOCATED = 'UNALLOCATED',
  ALL_RESPONSES_RECEIVED = 'ALL_RESPONSES_RECEIVED',
}
